
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum CompanyResponsibleType {
	Primary = 0
}
export namespace CompanyResponsibleType {
	export function getKeys(): Map<CompanyResponsibleType, string> {
		return new Map([[0, 'Primary']]);
	}
}
